import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FormFieldsModule } from '@app/base-components';
import { I18nModule, provideConfig } from 'haba-core';
import { CmsPageGuard, FormErrorsModule, PageLayoutComponent } from 'haba-storefrontlib';
import { CatalogFormComponent } from 'src/app/catalog/catalog-form/catalog-form.component';
import { CatalogPageComponent } from 'src/app/catalog/catalog-page/catalog-page.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    FormFieldsModule,
    FormErrorsModule,
    RouterModule.forChild([
      {
        path: null,
        component: PageLayoutComponent,
        canActivate: [CmsPageGuard],
        data: { cxRoute: 'catalog' },
      },
    ]),
    CatalogPageComponent,
    CatalogFormComponent,
  ],
  providers: [
    provideConfig({
      routing: {
        routes: {
          catalog: { paths: ['kataloganforderung'] },
        },
      },
      cmsComponents: {
        ContentfulCatalogPageComponent: {
          component: CatalogPageComponent,
        },
      },
      layoutSlots: {
        CatalogTemplate: {
          slots: ['CatalogContentSlot', 'CatalogFormSlot'],
        },
      },
    }),
  ],
})
export class CatalogModule {}
